module.exports = __webpack_public_path__ + "static/media/tooltipIcon.147093a0.png";